import { createDebugConfig, trackCustomEvent } from '@/configuration/setup/googleAnalytics';

const trackFeedbackBannerEvent = (eventName: string, additionalData: Record<string, unknown> = {}) => {
    const debugConfig = createDebugConfig();

    trackCustomEvent(
        eventName,
        {
            flow_name: 'overview',
            ...additionalData,
        },
        debugConfig
    );
};

export const trackFeedbackBannerClose = () => {
    trackFeedbackBannerEvent('close_feedback_banner', {
        trigger: 'click',
        element_name: 'feedback_banner',
    });
};

export const trackFeedbackBannerSubmit = (rating: number) => {
    trackFeedbackBannerEvent('submit_feedback_banner', {
        trigger: 'click',
        element_name: 'feedback_banner',
        element_state: rating,
    });
};
